import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "SidebarFriendsFilter"
})

export class FriendsSearchPipe implements PipeTransform {
    transform(value: any[], args?: any): any {

        if (!value) return null;
        if (!args) return value;

        args = args.toLowerCase();

        return value.filter((item) => {
            return item.friendProfile.firstname.toLowerCase().indexOf(args.toLowerCase()) > -1 || item.friendProfile.lastname.toLowerCase().indexOf(args.toLowerCase()) > -1;
        });
    }
}